import { initializeLocalization } from 'owa-localize';
import { initializeOwaTimeFormatTranslations } from 'owa-timeformat-localization';
import { initializeOwaDateTimeTranslations } from 'owa-datetime-localization';

export async function initializeOwaLocalization(
    culture: string,
    bootStrings: Record<string, string>
) {
    await Promise.all([
        initializeLocalization(culture, bootStrings),

        /**
         * Any shared packages that are used in boot should have their
         * localization initialized here. Any shared packages *not* used in boot
         * should have their localization initialized by the LazyModule which loads
         * the shared package
         */
        initializeOwaTimeFormatTranslations(),
        initializeOwaDateTimeTranslations(),
    ]);
}
